import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const DEFAULT = {
  titolo: "AGEVOLAZIONI",
  headers: { nome: "", e: "", listino: "LISTINO", rate: "RATE", nove_rate: "9 RATE", agevolata: "AGEVOLATA" },
  righe: [
    { nome: "PRIMARIA", e: 3, listino: 620, rate: 9, agevolata: 140 },
    { nome: "SECONDARIA", e: 3, listino: 1120, rate: 9, agevolata: 255 },
  ],
};

const n = (v) => { const x = parseFloat(String(v).replace(",", ".")); return isNaN(x) ? 0 : x; };
const fmt = (v) => n(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const noveRate = (r) => { const rt = n(r.rate); return rt ? (n(r.e) * n(r.listino)) / rt : 0; };

const cellTd = { border: "1px solid #b0b7c3", padding: 0 };
const cellInput = { width: "100%", border: "none", outline: "none", padding: "7px 8px", fontSize: 13, boxSizing: "border-box", background: "transparent", textAlign: "right" };

export default function ConfiguratoreAgevStandard({ onClose }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [titolo, setTitolo] = useState(DEFAULT.titolo);
  const [headers, setHeaders] = useState(DEFAULT.headers);
  const [righe, setRighe] = useState(DEFAULT.righe);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/agevolazioni/config-standard");
        setTitolo(r.data.titolo || DEFAULT.titolo);
        setHeaders({ ...DEFAULT.headers, ...(r.data.headers || {}) });
        setRighe(Array.isArray(r.data.righe) && r.data.righe.length ? r.data.righe : DEFAULT.righe);
      } catch (e) {
        toast.error("Errore nel caricamento del configuratore");
      } finally { setLoading(false); }
    })();
  }, []);

  const setCell = (idx, key, val) => setRighe(rs => rs.map((r, i) => i === idx ? { ...r, [key]: val } : r));
  const addRiga = () => setRighe(rs => [...rs, { nome: "", e: 0, listino: 0, rate: 9, agevolata: 0 }]);
  const delRiga = (idx) => setRighe(rs => rs.filter((_, i) => i !== idx));

  const salva = async () => {
    setSaving(true);
    try {
      await api.put("/agevolazioni/config-standard", { titolo, headers, righe });
      toast.success("Configuratore salvato");
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nel salvataggio");
    } finally { setSaving(false); }
  };

  const th = { border: "1px solid #b0b7c3", background: "#1b5e20", color: "white", padding: "8px 8px", fontSize: 12, fontWeight: 800, textAlign: "center" };

  return (
    <div data-testid="config-agev-modal" onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: "white", width: "100%", maxWidth: 760, maxHeight: "92vh", overflowY: "auto", borderRadius: 8 }}>
        <div style={{ background: "#6a1b9a", color: "white", padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0 }}>
          <strong>⚙ Configuratore Agevolazione Standard</strong>
          <button onClick={onClose} data-testid="config-agev-close" style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: 20 }}>✕</button>
        </div>

        <div style={{ padding: 20 }}>
          {loading ? (
            <div style={{ padding: 30, textAlign: "center", color: "#666" }}>Caricamento…</div>
          ) : (
            <>
              <input data-testid="config-agev-titolo" value={titolo} onChange={e => setTitolo(e.target.value)}
                style={{ width: "100%", textAlign: "center", fontSize: 18, fontWeight: 800, letterSpacing: 1, color: "#1b5e20", border: "1px solid #b0b7c3", borderBottom: "none", padding: "10px 8px", boxSizing: "border-box", background: "#f1f8e9" }} />
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ ...th, textAlign: "left", background: "#455a64" }}>Scuola</th>
                    <th style={th}>{headers.e || "E"}</th>
                    <th style={th}>{headers.listino || "LISTINO"}</th>
                    <th style={th}>{headers.rate || "RATE"}</th>
                    <th style={{ ...th, background: "#2e7d32" }}>{headers.nove_rate || "9 RATE"}</th>
                    <th style={th}>{headers.agevolata || "AGEVOLATA"}</th>
                    <th style={{ ...th, background: "#455a64", width: 34 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {righe.map((r, idx) => (
                    <tr key={idx} data-testid={`config-agev-row-${idx}`}>
                      <td style={cellTd}>
                        <input data-testid={`config-agev-nome-${idx}`} value={r.nome ?? ""} onChange={e => setCell(idx, "nome", e.target.value)}
                          style={{ ...cellInput, textAlign: "left", fontWeight: 700 }} />
                      </td>
                      <td style={cellTd}>
                        <input data-testid={`config-agev-e-${idx}`} value={r.e ?? ""} onChange={e => setCell(idx, "e", e.target.value)} inputMode="decimal" style={cellInput} />
                      </td>
                      <td style={cellTd}>
                        <input data-testid={`config-agev-listino-${idx}`} value={r.listino ?? ""} onChange={e => setCell(idx, "listino", e.target.value)} inputMode="decimal" style={cellInput} />
                      </td>
                      <td style={cellTd}>
                        <input data-testid={`config-agev-rate-${idx}`} value={r.rate ?? ""} onChange={e => setCell(idx, "rate", e.target.value)} inputMode="decimal" style={cellInput} />
                      </td>
                      <td data-testid={`config-agev-noverate-${idx}`} style={{ ...cellTd, background: "#e8f5e9", textAlign: "right", padding: "7px 8px", fontSize: 13, fontWeight: 800, color: "#1b5e20" }} title="Formula: E × LISTINO ÷ RATE">
                        {fmt(noveRate(r))}
                      </td>
                      <td style={cellTd}>
                        <input data-testid={`config-agev-agevolata-${idx}`} value={r.agevolata ?? ""} onChange={e => setCell(idx, "agevolata", e.target.value)} inputMode="decimal" style={cellInput} />
                      </td>
                      <td style={{ ...cellTd, textAlign: "center" }}>
                        <button data-testid={`config-agev-del-${idx}`} onClick={() => delRiga(idx)} title="Elimina riga"
                          style={{ background: "none", border: "none", color: "#c62828", cursor: "pointer", fontSize: 15 }}>🗑</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ fontSize: 11, color: "#777", marginTop: 8 }}>
                La colonna <b>9 RATE</b> è calcolata automaticamente: <code>E × LISTINO ÷ RATE</code>. Modifica i valori e salva.
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
                <button data-testid="config-agev-add" onClick={addRiga}
                  style={{ padding: "7px 14px", background: "#eceff1", color: "#37474f", border: "1px solid #cfd8dc", borderRadius: 4, fontWeight: 700, cursor: "pointer" }}>+ Aggiungi riga</button>
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={onClose} data-testid="config-agev-cancel"
                    style={{ padding: "8px 14px", background: "#eceff1", color: "#37474f", border: "none", borderRadius: 4, fontWeight: 600, cursor: "pointer" }}>Annulla</button>
                  <button onClick={salva} disabled={saving} data-testid="config-agev-save"
                    style={{ padding: "8px 20px", background: saving ? "#9e9e9e" : "#1b5e20", color: "white", border: "none", borderRadius: 4, fontWeight: 800, cursor: saving ? "wait" : "pointer" }}>
                    {saving ? "Salvataggio…" : "💾 Salva"}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
